import Table, { ColumnsType } from "antd/lib/table";
import { Modal, Switch, Tag, Tooltip } from "antd";
import Draggable from "react-draggable";

import { TableHelper } from "../../../../util/TableHelper";
import Loading from "../../../common/Loading";
import styles from "./index.module.less";
import { useMobileUserList } from "./index.hook";
import Authentication from "../../../../util/Authentication";
import { Modules, Operations } from "../../../../constants/DatabaseConstants/MasterConstant";
import LocalStorageUtil from "../../../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../../../constants/ApplicationConstants/LocalStorageConstants";
import { useReactDraggable } from "../../../../hooks/useReactDraggable";

import type { GetAllMobileUserResponse } from "../../../../shared/interface/UserManagement/mobileUser.interface";
import type { UserInterface } from "../../../../shared/interface/auth/User.interface";
import { MobileOutlined, UserOutlined, UserSwitchOutlined } from "@ant-design/icons";

const MobileUserList = (props: { searchedText: string }) => {
  const config = useMobileUserList({ searchedText: props.searchedText });
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  const { bounds, onStart } = useReactDraggable();

  const renderText = (text: string | number) => {
    return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
  };

  const renderNumberValue = (text: string | number) => {
    return <div className="gx-text-right">{TableHelper.getValue(text)}</div>;
  };

  const columns: ColumnsType<GetAllMobileUserResponse> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between" }} className={`${record?.id === config?.userId && styles["modal__description"]}`}>
          <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>{TableHelper.getValue(text)}</span>
          <span>{record?.fcmTokenList?.length > 0 && <MobileOutlined />}</span>
        </div>
      ),
      sorter: {
        compare: TableHelper.valueCompare("full_name")
      }
    },
    {
      align: "left",
      title: "Mobile Number",
      dataIndex: "mobile_number",
      render: renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("mobile_number")
      }
    },
    {
      align: "left",
      title: "Email Address",
      dataIndex: "email_address",
      key: "email_address",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("email_address")
      }
    },
    {
      align: "left",
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a, b) => (a.is_active === false ? -1 : 1),
      render: (text, record) => <div className="table-text-wrap">{text === true ? <Tag color="success">Active</Tag> : <Tag color="error">In-Active</Tag>}</div>
    },
    {
      align: "left",
      title: "Actions",
      fixed: "right",
      key: "actions",
      width: "10%",
      render: (text, record) => (
        <div className={`${styles["actionAllDevice"]}`}>
          {Authentication.hasModuleAndOperationAccess(userData, Modules.MOBILE_USER, Operations.DELETE) && (
            <Tooltip title={record?.is_active ? "Active" : "In-Active"} getPopupContainer={(trigger) => trigger.parentElement || document.body}>
              <span className={"gx-link"}>
                <Switch checked={record?.is_active} onClick={config?.handleDeleteUser.bind(this, record)} className={styles["action-icon"]} />
              </span>
            </Tooltip>
          )}
        </div>
      )
    }
  ];

  return (
    <div>
      {config?.loading && <Loading />}

      {!config?.loading && <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config?.filteredTableData} pagination={config?.pagination} onChange={config?.handleChangePagination} rowKey={(record) => record.sr_no} bordered />}

      <Modal
        title={<div className="modal-container">{`Active/In-Active Confirmation`}</div>}
        open={config?.showDeleteModal}
        onCancel={config.handleCancel}
        onOk={config.handleOk}
        okText="Yes"
        cancelText="No"
        width="580px"
        destroyOnClose
        maskClosable={false}
        wrapClassName="delete-modal"
        modalRender={(modal) => (
          <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
            {modal}
          </Draggable>
        )}
        okButtonProps={{
          disabled: config?.saving,
          loading: config?.saving
        }}
      >
        <h4>
          {`Are you sure you want to ${config.isActive ? "inactivate" : "activate"} the account for mobile user`} <span className={styles["modal__description"]}>{config.userName}</span> ?
        </h4>
      </Modal>
    </div>
  );
};

export default MobileUserList;
